import { render, staticRenderFns } from "./CcModal.ts.vue?vue&type=template&id=0513bd62"
import script from "./CcModal.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CcModal.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CcModal.ts.vue?vue&type=style&index=0&id=0513bd62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports